import { Festival } from '../Types/Festival';
import * as constData from './DataConstants';
import {buildTiers} from './GetTiers';

export function GetData(): Festival {
 return {
        name: 'Riot Fest 2026',
        gaPrice: constData.gaPrice,
        gaTierHistory: constData.getGaTierHistoryText(),
        lastUpdated: constData.lastUpdated,
        maxPrice:constData.deluxePlusPrice,
        ticketTiers: buildTiers()
      }
}